import { render, staticRenderFns } from "./SponsorsSection.vue?vue&type=template&id=048a6900&scoped=true&"
import script from "./SponsorsSection.vue?vue&type=script&lang=js&"
export * from "./SponsorsSection.vue?vue&type=script&lang=js&"
import style0 from "./SponsorsSection.vue?vue&type=style&index=0&id=048a6900&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "048a6900",
  null
  
)

export default component.exports